/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins'
import * as Sentry from "@sentry/vue";

// Components
import App from './App.vue'

// Routes

// Composables
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPersistedstate from 'pinia-plugin-persistedstate'
import { useGlobalDialog } from './composables/globalDialog'
import { useAppStore } from './stores/app'
import router from './router';

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPersistedstate)

const globalDialog = useGlobalDialog()
app.provide('globalDialog', globalDialog)

registerPlugins(app)

app.use(pinia)
const appStore = useAppStore()

router.afterEach(() => {
  appStore.checkForEmailIntercept()
})

Sentry.init({
  app,
  dsn: "https://0c8974d551414e7a37e8e12a3dd83c31@o4510743772397568.ingest.us.sentry.io/4510743779934208",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: process.env.SENTRY_ENVIRONMENT || 'local',
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })
  ],
  // Session Replay
  replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.mount('#lynx-app')
